/* Imports */
import React from "react"
import { v4 as uuid } from "uuid"
import { Font, Table, Section } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import allColors from "../../data/all-colors"
import allOverlays from "../../data/all-overlays"
import allFontFamilies from "../../data/all-font-families"
import allFontSizes from "../../data/all-font-sizes"
import allFontWeights from "../../data/all-font-weights"
import allLineHeights from "../../data/all-line-heights"
import allShadows from "../../data/all-shadows"
import allRadiuses from "../../data/all-radiuses"
import allSpacers from "../../data/all-spacers"
import allTransitions from "../../data/all-transitions"
import allLayouts from "../../data/all-layouts"

const VariablesPage = () => {
    const allLists = [
        {
            name: "Colors",
            list: allColors,
        },
        {
            name: "Overlay",
            list: allOverlays,
        },
        {
            name: "Font families",
            list: allFontFamilies,
        },
        {
            name: "Font sizes",
            list: allFontSizes,
        },
        {
            name: "Font weights",
            list: allFontWeights,
        },
        {
            name: "Line heights",
            list: allLineHeights,
        },
        {
            name: "Shadows",
            list: allShadows,
        },
        {
            name: "Radiuses",
            list: allRadiuses,
        },
        {
            name: "Spacers",
            list: allSpacers,
        },
        {
            name: "Transitions",
            list: allTransitions,
        },
    ]

    return (
        <ComponentPage>
            {allLists.map(list => (
                <Section gap="small" key={uuid()}>
                    <Font.H2>{list.name}</Font.H2>

                    <Table tableStyle="bordered" vAlign="top">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Variable</th>
                                <th>CSS</th>
                                <th>Value</th>
                            </tr>
                        </thead>

                        <tbody>
                            {list.list.map(item => (
                                <tr key={uuid()}>
                                    <td>{item.name}</td>
                                    <td>{item.variable}</td>
                                    <td>{item.css}</td>
                                    <td>{list.name === "Colors" ? item.rgb : item.value}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Section>
            ))}

            <Section gap="small">
                <Font.H2>Layouts</Font.H2>

                <Table tableStyle="bordered" vAlign="top">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Variable</th>
                            <th>CSS</th>
                            <th>Value</th>
                            <th>Value tablet</th>
                        </tr>
                    </thead>

                    <tbody>
                        {allLayouts.map(item => (
                            <tr key={uuid()}>
                                <td>{item.name}</td>
                                <td>{item.variable}</td>
                                <td>{item.css}</td>
                                <td>{item.value}</td>
                                <td>{item.valueTablet}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Section>
        </ComponentPage>
    )
}

export default VariablesPage
